export default function ProgramLucruPage() {
  return (
    <div className="min-h-screen bg-gray-50">
      <main className="flex-grow max-w-7xl mx-auto px-4 py-8 space-y-8">
        <div className="bg-white rounded-lg shadow p-6 space-y-4">
          <div className="md:flex gap-7">
            <div>
              <h2 className="text-xl font-semibold">
                PROGRAM DE LUCRU AL COMPARTIMENTULUI SECRETARIAT
              </h2>
              <ul className="list-disc list-inside text-gray-700 space-y-2">
                <li>
                  <span className="font-medium">Luni:</span> 8:00–16:00
                </li>
                <li>
                  <span className="font-medium">Marți:</span> 8:00–18:00
                </li>
                <li>
                  <span className="font-medium">Miercuri:</span> 8:00–18:00
                </li>
                <li>
                  <span className="font-medium">Joi:</span> 8:00–16:00
                </li>
                <li>
                  <span className="font-medium">Vineri:</span> 8:00–14:00
                </li>
              </ul>
            </div>
            <div className="md:mt-0 mt-3">
              <h2 className="text-xl font-semibold">
                PROGRAM CU PUBLICUL AL COMPARTIMENTULUI SECRETARIAT
              </h2>
              <ul className="list-disc list-inside text-gray-700 space-y-2">
                <li>
                  <span className="font-medium">Luni:</span> 12:00–14:00
                </li>
                <li>
                  <span className="font-medium">Marți:</span> 16:00–18:00
                </li>
                <li>
                  <span className="font-medium">Miercuri:</span> 16:00–18:00
                </li>
                <li>
                  <span className="font-medium">Joi:</span> 12:00–14:00
                </li>
                <li>
                  <span className="font-medium">Vineri:</span> 12:00–14:00
                </li>
              </ul>
            </div>
          </div>

          <h2 className="text-xl font-semibold">
            PROGRAM DE LUCRU DIRECTOR/DIRECTOR ADJUNCT ȘI PERSONAL DIDACTIC
            AUXILIAR
          </h2>
          <ul className="list-disc list-inside text-gray-700 space-y-2">
            <li>
              <span className="font-medium">Luni- Joi:</span> 8:00–16:30
            </li>
            <li>
              <span className="font-medium">Vineri:</span> 8:00–14:00
            </li>
          </ul>
          <p className="text-gray-700">
            <span className="font-medium">Telefon:</span> 0362 405 475
          </p>
          <p className="text-gray-700">
            <span className="font-medium">E-mail:</span> liceul_ulmeni@yahoo.ro
          </p>

          <h2 className="text-xl font-semibold">
            PROGRAMUL DE AUDIENȚĂ AL CONDUCERII
          </h2>
          <ul className="list-disc list-inside text-gray-700 space-y-2">
            <li>Director, prof. Rus Anca Crina, joi, între orele 10:00-12:00</li>
            <li>Director adjunct, prof. China Maria, joi, între orele 12:00-14:00</li>
          </ul>

          <h2 className="text-xl font-semibold">
            Orele dedicate întâlnirilor diriginților cu părinții
          </h2>
          <ul className="list-disc list-inside text-gray-700 space-y-2">
            <li>luni între orele 13:00-15:00</li>
          </ul>  
        </div>
      </main>
    </div>
  );
}
